import {Philosophy} from '@/ui/blocks/philosophy';
import {useTranslation} from 'react-i18next';

export const PhilosophySection = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Philosophy
      intro={t('ui.philosophy.intro')}
      titleLine1={t('ui.philosophy.titleLine1')}
      titleLine2={t('ui.philosophy.titleLine2')}
      description={t('ui.philosophy.description')}
      quote={t('ui.philosophy.quote')}
      tagline={t('ui.philosophy.tagline')}
    />
  );
};
